import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import IsPrivate from "../components/authComponents/IsPrivate";
import IsLoggedin from "../components/authComponents/IsLoggedin";
import Login from "../pages/Login";
import Signup from "../pages/Signup";
import FleetLayout from "../pages/FleetLayout";
import AssignmentKanban from "../pages/AssignmentKanban";
import OrderHistory from "../pages/OrderHistory";
import DriverStatus from "../pages/DriverStatus";
import SetUp from "../pages/SetUp";
import Account from "../pages/Account";
import Billing from "../pages/Billing";
import Welcome from "../pages/Welcome";
import Library from "../pages/Library";
import Parking from "../pages/Parking";
import Directory from "../pages/Directory";
import PublicOrder from "../pages/TransportOrderPublic";
import ErrorBoundary from "../components/ErrorBoundary";
import NoAccess from "../pages/NoAccess";
import MaintenancePlaceholder from "../pages/MaintenancePlaceholder";
import AcceptMemberInvite from "../pages/AcceptMemberInvite";
import { FleetRoles } from "../auth/fleetRoles";

function LoginRouteAlias() {
  const location = useLocation();
  return <Navigate to={`/${location.search || ""}`} replace />;
}

export default function AppRouter({ funcNav, themeColors, themeUpdater, logoUpdater }) {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <IsLoggedin>
            <Login funcNav={funcNav} />
          </IsLoggedin>
        }
      />
      <Route
        path="/welcome"
        element={
          <IsPrivate allowedRoles={[FleetRoles.OWNER, FleetRoles.EXECUTIVE, FleetRoles.OPERATIONS]}>
            <Welcome funcNav={funcNav} />
          </IsPrivate>
        }
      />

      <Route
        path="/login"
        element={<LoginRouteAlias />}
      />
      <Route path="/transport" element={<Navigate to="/transports" replace />} />
      <Route path="/driverStatus" element={<Navigate to="/drivers" replace />} />
      <Route
        path="/signup"
        element={
          <IsLoggedin>
            <Signup funcNav={funcNav} />
          </IsLoggedin>
        }
      />
      <Route
        path="/map"
        element={
          <IsPrivate allowedRoles={[FleetRoles.OWNER, FleetRoles.EXECUTIVE, FleetRoles.OPERATIONS]}>
            <FleetLayout />
          </IsPrivate>
        }
      />
      <Route
        path="/transports"
        element={
          <IsPrivate allowedRoles={[FleetRoles.OWNER, FleetRoles.EXECUTIVE, FleetRoles.OPERATIONS]}>
            <ErrorBoundary>
              <AssignmentKanban />
            </ErrorBoundary>
          </IsPrivate>
        }
      />
      <Route
        path="/orders-history"
        element={
          <IsPrivate allowedRoles={[FleetRoles.OWNER, FleetRoles.EXECUTIVE, FleetRoles.OPERATIONS]}>
            <ErrorBoundary>
              <OrderHistory />
            </ErrorBoundary>
          </IsPrivate>
        }
      />
      <Route
        path="/drivers"
        element={
          <IsPrivate
            allowedRoles={[
              FleetRoles.OWNER,
              FleetRoles.EXECUTIVE,
              FleetRoles.OPERATIONS,
              FleetRoles.HHRR,
            ]}
          >
            <DriverStatus />
          </IsPrivate>
        }
      />

      <Route
        path="/billing"
        element={
          <IsPrivate allowedRoles={[FleetRoles.OWNER, FleetRoles.EXECUTIVE]}>
            <ErrorBoundary>
              <Billing />
            </ErrorBoundary>
          </IsPrivate>
        }
      />
      <Route
        path="/account"
        element={
          <IsPrivate
            allowedRoles={[
              FleetRoles.OWNER,
              FleetRoles.EXECUTIVE,
              FleetRoles.OPERATIONS,
              FleetRoles.MAINTENANCE,
              FleetRoles.HHRR,
            ]}
          >
            <ErrorBoundary>
              <Account />
            </ErrorBoundary>
          </IsPrivate>
        }
      />
      <Route
        path="/setup"
        element={
          <IsPrivate allowedRoles={[FleetRoles.OWNER, FleetRoles.EXECUTIVE]}>
            <ErrorBoundary>
              <SetUp themeColors={themeColors} themeUpdater={themeUpdater} logoUpdater={logoUpdater} />
            </ErrorBoundary>
          </IsPrivate>
        }
      />
      <Route
        path="/library"
        element={
          <IsPrivate
            allowedRoles={[
              FleetRoles.OWNER,
              FleetRoles.EXECUTIVE,
              FleetRoles.OPERATIONS,
              FleetRoles.HHRR,
            ]}
          >
            <Library />
          </IsPrivate>
        }
      />
      <Route
        path="/directory"
        element={
          <IsPrivate allowedRoles={[FleetRoles.OWNER, FleetRoles.EXECUTIVE, FleetRoles.OPERATIONS]}>
            <ErrorBoundary><Directory /></ErrorBoundary>
          </IsPrivate>
        }
      />
      <Route
        path="/parking"
        element={
          <IsPrivate
            allowedRoles={[
              FleetRoles.OWNER,
              FleetRoles.EXECUTIVE,
              FleetRoles.OPERATIONS,
              FleetRoles.HHRR,
            ]}
          >
            <Parking />
          </IsPrivate>
        }
      />
      <Route path="/accept-invite" element={<AcceptMemberInvite />} />
      <Route path="/maintenance" element={<MaintenancePlaceholder />} />
      <Route path="/no-access" element={<NoAccess />} />
      <Route
        path="/publicLink/fleets/:fleetId/transportOrderId/:transportOrderId/:token"
        element={<PublicOrder />}
      />
      <Route
        path="/publicLink/fleet/:fleetId/transportOrderId/:transportOrderId/:token"
        element={<PublicOrder />}
      />
      <Route
        path="*"
        element={
          <IsPrivate>
            <Navigate to="/welcome" replace />
          </IsPrivate>
        }
      />
    </Routes>
  );
}
